import type { ValueSetSearchParams } from '@quromedical/models';
import { trpcClient } from 'trpc';

export class ValueSetApi {
  getIcd10Codes = async (params: ValueSetSearchParams = {}) =>
    trpcClient.icd10.getAll.query(params);
}
